export function locationFactory() {
    return window.location;
}